import type { GeofenceStatus } from "@crewledger/shared/schemas";
import { geofenceStatusLabel } from "@crewledger/shared/geofence";
import { cn } from "@/lib/utils";

const STATUS_STYLES: Record<GeofenceStatus, string> = {
  VERIFIED_ON_SITE: "bg-green-100 text-green-900 border-green-200",
  OUTSIDE_GEOFENCE: "bg-amber-100 text-amber-900 border-amber-200",
  GPS_UNAVAILABLE: "bg-slate-100 text-slate-800 border-slate-200",
  MANUAL_ENTRY: "bg-slate-100 text-slate-700 border-slate-200",
  MANAGER_OVERRIDE: "bg-orange-100 text-orange-900 border-orange-200",
};

interface GeofenceStatusBadgeProps {
  status: GeofenceStatus | null | undefined;
  className?: string;
}

export function GeofenceStatusBadge({ status, className }: GeofenceStatusBadgeProps) {
  if (!status) return null;

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
        STATUS_STYLES[status],
        className,
      )}
      title={geofenceStatusLabel(status)}
    >
      {geofenceStatusLabel(status)}
    </span>
  );
}
